import request from '@/utils/request'
import { getLoginType, LOGIN_TYPES } from '@/utils/auth'

function getUserListUrl () {
  return getLoginType() === LOGIN_TYPES.SHOP
    ? '/min/app/user/queryShopAppUserPageList'
    : '/min/app/user/queryMinAppUserPageList'
}

function getExportUrl () {
  return getLoginType() === LOGIN_TYPES.SHOP
    ? '/min/app/user/exportShopUserToExcel'
    : '/min/app/user/exportAppUserToExcel'
}

/* 列表 */
export function queryMinAppUserPageList (data) {
  return request({
    url: getUserListUrl(),
    method: 'POST',
    data
  })
}

/* 列表-详情（平台管理） */
export function queryShopAppUserListByUserId (data) {
  return request({
    url: '/min/app/user/queryShopAppUserListByUserId',
    method: 'POST',
    data
  })
}

/* 列表-详情-店铺搜索数据（平台管理） */
export function queryAllShopInfoList (data) {
  return request({
    url: '/shop/info/queryAllShopInfoList',
    method: 'POST',
    data
  })
}

/* 会员等级列表 */
export function queryAllUserMemberLevelList (data) {
  return request({
    url: '/min/app/user/queryAllUserMemberLevelList',
    method: 'POST',
    data
  })
}

/* 获取小程序用户信息表明细 */
export function fetchWebMinAppUserDetailById (data) {
  return request({
    url: '/min/app/user/fetchWebMinAppUserDetailById',
    method: 'POST',
    data
  })
}

/* 修改小程序用户信息表 */
export function updateMinAppUser (data) {
  return request({
    url: '/min/app/user/updateMinAppUser',
    method: 'POST',
    data
  })
}

/* 核销记录 */
export function queryUserYearCardLogPageList (data) {
  return request({
    url: '/user/year/card/log/queryUserYearCardLogPageList',
    method: 'POST',
    data
  })
}

// 导出Excel
export function exportExcel (data) {
  return request({
    url: getExportUrl(),
    method: 'POST',
    data,
    responseType: 'blob'
  })
}

/* 获取所有企业信息列表-分公司数据 */
export function queryEnterprisePageList (data) {
  return request({
    url: '/enterprise/queryEnterprisePageList',
    method: 'POST',
    data
  })
}

/* 变更余额-增加余额 */
export function addMoney (data) {
  return request({
    url: '/min/app/user/addMoney',
    method: 'POST',
    data
  })
}

/* 变更余额-减少余额 */
export function subMoney (data) {
  return request({
    url: '/min/app/user/subMoney',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js